module.exports = __webpack_public_path__ + "img/Dantam Bridal 15b.d0ce5704.jpg";